export default __webpack_public_path__ + "static/media/team.cd7e4cee.png";